import { IEventStatus } from "../BuildStatus";
import { Grid, Tooltip, Typography } from "@mui/material";
import CalendarToday from "@mui/icons-material/CalendarToday";
import { formatDateString } from "src/components/DateDisplay";

interface IDateInfo extends IEventStatus {
  start: number;
  end: number;
}

export const PendingDateInfo = (props: IDateInfo): JSX.Element => {
  const departureDate = formatDateString(new Date(props?.scheduledOut ?? props?.start), "Etc/UTC", true);
  const arrivalDate = formatDateString(new Date(props?.scheduledIn ?? props?.end), "Etc/UTC", true);
  const departureDay = new Date(props?.scheduledOut ?? props?.start ?? props.scheduledStart).getUTCDate();
  const arrivalDay = new Date(props?.scheduledIn ?? props?.end ?? props.scheduledEnd).getUTCDate();

  return (
    <Grid container style={{ width: "auto" }}>
      <Tooltip disableFocusListener disableTouchListener title={`Start: ${departureDate}`}>
        <div style={{ position: "relative", height: 20, width: 20, marginRight: 5 }}>
          <CalendarToday />
          <Typography style={{ position: "absolute", top: 7, left: 6, fontSize: 10, color: "#A4BED6" }}>
            {departureDay}
          </Typography>
        </div>
      </Tooltip>
      <Tooltip disableFocusListener disableTouchListener title={`End: ${arrivalDate}`}>
        <div style={{ position: "relative", height: 20, width: 20, marginRight: 5 }}>
          <CalendarToday />
          <Typography style={{ position: "absolute", top: 7, left: 6, fontSize: 10, color: "#A4BED6" }}>
            {arrivalDay}
          </Typography>
        </div>
      </Tooltip>
    </Grid>
  );
};
